import { useState, useEffect } from "react";

/**
 * A custom React hook for creating a typewriter animation effect on a string.
 *
 * @param {string} text - The full text to be typed out.
 * @param {number} speed - The speed of the typing in milliseconds per character.
 * @param {boolean} start - A boolean flag to start the typing animation.
 * @returns {string} The progressively typed-out string.
 */

const useTypewriter = (text, speed = 50, start = false) => {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    // Don't start typing until the start flag is true
    if (!start) return;

    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < text.length) {
        setDisplayText(text.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, speed);

    // Cleanup function to clear the interval if the component unmounts
    // or if the dependencies (text, speed, start) change.
    return () => clearInterval(typingInterval);
  }, [text, speed, start]); // Re-run effect if these change

  return displayText;
};

export default useTypewriter;
